//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import QrcodeVue from "qrcode.vue";
export default {
    name: "alliance_coupondetail",
    components: { QrcodeVue },
    data() {
        return {
            title: "优惠券详情",
            id: this.$route.query.id,
            detail: "",
            codeValue: "", //二维码
            codeSize: 110, //二维码大小
            url: window.location.href //当前地址
        };
    },
    created() {
        if (sessionStorage.getItem("token") == null) {
            this.get_token(this.url);
        } else {
            this.get_detail();
        }
    },
    methods: {
        //获取token
        get_token(url) {
            var self = this;
            this.$EpetJs.Common.approve(url,function() {
                self.get_detail();
            }); //生成token
        },
        //获取优惠券详情
        get_detail() {
            var self = this;
            this.$EpetJs.Common.get("/v2/public/user/gifts/" + this.id, {}).then(
                ({ data }) => {
                    if (data.status_code == "200") {
                        this.detail = data.data;
                        this.codeValue = this.detail.code;
                    }
                }
            );
        }
    }
};
